'use strict';
/*
  brat — deadpan lime. Flat lime-green field, plain lowercase Arial nudged
  slightly out of focus (the low-res blur), no decoration. Over footage each
  word sits in a lime bar; the key word inverts to a black bar with lime text.
*/
const { FONTS } = require('../lib/draw');
const { layoutCue } = require('./_common');

const palette = { bg: '#8ace00', fg: '#0a0a0a', accent: '#0a0a0a', ink: '#0a0a0a' };

function init(st){ st.s.font = st.tk.registerFamily('ForgeBrat', FONTS.arialBlack) || undefined; }

function background(ctx, st){
  if (!st.overlayMode) { ctx.fillStyle = palette.bg; ctx.fillRect(0, 0, st.W, st.H); }
}

function paintToken(ctx, o){
  const { T, cx, cy, px, scl, alpha, emph, st, ghost } = o, tk = st.tk;
  const t = T.toLowerCase();
  ctx.save(); ctx.globalAlpha = alpha; ctx.translate(cx, cy); ctx.scale(scl, scl);
  ctx.font = tk.font(px, 800, st.s.font); ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
  if (ghost) { ctx.fillStyle = 'rgba(10,10,10,0.4)'; ctx.fillText(t, 0, 0); ctx.restore(); return; }
  // lime (or inverted) bar behind the word
  ctx.fillStyle = emph ? '#0a0a0a' : palette.bg;
  tk.chip(ctx, t, px, 0.26, 0.30, px * 0.04); ctx.fill();
  // out-of-focus lowercase text: a few low-alpha offset passes, then a sharper centre
  const col = emph ? palette.bg : palette.fg;
  ctx.fillStyle = col; ctx.globalAlpha = alpha * 0.34;
  for (const d of [[-2.5, 0], [2.5, 0], [0, -2.5], [0, 2.5], [-1.8, 1.8], [1.8, -1.8]]) ctx.fillText(t, d[0], d[1]);
  ctx.globalAlpha = alpha * 0.85; ctx.fillText(t, 0, 0);
  ctx.restore();
}

function drawCue(ctx, st){
  const anchor = st.mode === 'talk' ? 0.76 : 'center';
  layoutCue(ctx, st, { sizes: { big: 132, mid: 110, small: 60 }, anchor, safeW: 0.84, reveal: 0.22, stagger: 0.05, trans: 0.16, family: st.s.font, paintToken });
}

function overlay(ctx, st){
  const tk = st.tk;
  // faint grain only — brat is otherwise flat and undesigned
  ctx.save(); ctx.globalAlpha = 0.03; ctx.globalCompositeOperation = 'multiply'; ctx.drawImage(tk.grain(), -Math.random() * 100, -Math.random() * 100); ctx.restore();
  if (!st.overlayMode) { ctx.fillStyle = palette.ink; ctx.fillRect(0, st.H - 6, st.W * st.progress, 6); }
}

module.exports = { id: 'brat', label: 'Lime · deadpan bold', palette, init, background, drawCue, overlay, paintToken };
